import { TrackedValue } from '../TrackedValue';
import { Partner } from '@callback-cats/partnerships-ts/Partnership';

export const isPartnershipV2 = (object: unknown): object is Partner => {
  const partnership = object as Partner;
  return (
    !!partnership &&
    partnership.name !== undefined &&
    partnership.data !== undefined &&
    partnership.mode !== undefined
  );
};

export const isPartnershipArrayV2 = (object: unknown): object is Partner[] => {
  if (!Array.isArray(object)) {
    return false;
  }

  return object.every((item) => isPartnershipV2(item));
};

export const isTrackedPartnershipV2 = (
  object: unknown
): object is TrackedValue<Partner> => {
  const partnership = object as TrackedValue<Partner>;
  return (
    !!partnership &&
    partnership.value !== undefined &&
    isPartnershipV2(partnership.value)
  );
};

export const isTrackedPartnershipArrayV2 = (
  object: unknown
): object is TrackedValue<Partner>[] => {
  if (!Array.isArray(object)) {
    return false;
  }

  return object.every((item) => isTrackedPartnershipV2(item));
};
